import ng from 'angular';

import '@/components/account-activation/account-activation-template.scss';

export class TemplateAccountActivationFinishController {

    public model: boolean;
    public toggleCallback = async (value: boolean) => {};
    public requestLoading: boolean = false;

    public toggle = async (): Promise<void> => {
        if (this.requestLoading || !this.toggleCallback) return;
        this.requestLoading = true;
        setTimeout(async () => {
            await this.toggleCallback(this.model).finally(() => {
                this.requestLoading = false;
            });
        })

    }

}

export class TemplateAccountActivationFinishComponent implements ng.IComponentOptions {
    public bindings = {
        token: '<',
        model: '=',
        toggleCallback: '<?',
    };
    public template = require('./finish.html');
    public controller = TemplateAccountActivationFinishController;

}
